import { render, staticRenderFns } from "./SpotWidgetControl.global.vue?vue&type=template&id=c94b626e&lang=pug&"
import script from "./SpotWidgetControl.global.vue?vue&type=script&lang=ts&"
export * from "./SpotWidgetControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports